/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/social-export-api-client";
import type { GetYoutubeCategoriesQueryResponse, GetYoutubeCategoriesPathParams } from "../models/GetYoutubeCategories";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getYoutubeCategories } from "../axios/getYoutubeCategories";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getYoutubeCategoriesQueryKey = (station: GetYoutubeCategoriesPathParams["station"]) => ["social-export-api", { url: '/youtube/:station/categories', params: {station:station} }] as const

export type GetYoutubeCategoriesQueryKey = ReturnType<typeof getYoutubeCategoriesQueryKey>

export function getYoutubeCategoriesQueryOptions(station: GetYoutubeCategoriesPathParams["station"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getYoutubeCategoriesQueryKey(station)
        return queryOptions<GetYoutubeCategoriesQueryResponse, ResponseErrorConfig<Error>, GetYoutubeCategoriesQueryResponse, typeof queryKey>({
         enabled: !!(station),
         queryKey,
         queryFn: async ({ signal }) => {
            return getYoutubeCategories(station, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns available YouTube video categories based on the station country code
 * @summary Get YouTube video categories for a station
 * {@link /youtube/:station/categories}
 */
export function useGetYoutubeCategories<TData = GetYoutubeCategoriesQueryResponse, TQueryData = GetYoutubeCategoriesQueryResponse, TQueryKey extends QueryKey = GetYoutubeCategoriesQueryKey>(station: GetYoutubeCategoriesPathParams["station"], options: 
{
  query?: Partial<QueryObserverOptions<GetYoutubeCategoriesQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getYoutubeCategoriesQueryKey(station)
         

         const query = useQuery({
          ...getYoutubeCategoriesQueryOptions(station, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}